"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _generalStore = _interopRequireDefault(require("general-store"));

var GeneralStoreSetup = function GeneralStoreSetup() {
  // DIRTY ROTTEN HACK
  // the payload dispatched by handleViewAction v1 doesn't validate
  // in GeneralStore because it doesn't have an actionType
  // until the format gets sorted out, this should protect us
  // TODO colby: remove this
  _dispatcher.default.handleViewAction = function (action) {
    return this.dispatch({
      source: 'VIEW_ACTION',
      action: action,
      actionType: action.actionType || ''
    });
  }; // set the global dispatcher instance so we don't pass a
  // dispatcher to every register


  _generalStore.default.DispatcherInstance.set(_dispatcher.default);
};

var _default = GeneralStoreSetup;
exports.default = _default;
module.exports = exports.default;